import { Variants } from '../types/variant';

export const evalComplexeVariants = {
  fiche_coordination: {
    name: 'Fiche de coordination DAC',
    status: 'restricted',
    description:
      "Fiche d'évaluation et de coordination pour les situations complexes. Couvre l'identité, les intervenants professionnels et non professionnels, la synthèse et l'histoire médicale.",
    speciality: 'EVAL-COMPLEXE',
    patientOnboarding: 'DEFAULT',
    patientOffboarding: 'DIRECT_CONFIRMATION',
    emailTemplate: 'MED_G_DEFAULT',
    reportTemplate: 'FICHE_COORDINATION',
    initialQuestions: [] as string[],
    pages: {
      IDENTITE: {
        title: 'Identité',
        sections: ['IDENTITE'],
      },
      EVALUATION: {
        title: 'Évaluation',
        sections: ['EVALUATION'],
      },
      INTERVENANTS: {
        title: 'Intervenants',
        sections: ['INTERVENANTS_PRO', 'INTERVENANTS_NONPRO'],
      },
      SYNTHESE: {
        title: 'Synthèse',
        sections: ['SYNTHESE'],
      },
      HISTOIRE: {
        title: 'Histoire médicale',
        sections: ['ATCD_MEDICAUX', 'ALD_ALLERGIES', 'VACCINS_PREVENTION'],
      },
      CONCLUSION: {
        title: 'Conclusion',
        sections: ['RECAP'],
      },
    },
    initialAssertions: [],
    options: [],
    tag: 'EVAL',
  },
} satisfies Variants;
